import { ImageDimensions } from '../../entities/file-validation.types';

/**
 * Fallback ридер через Browser Image API.
 * Работает с любым форматом который поддерживает браузер.
 * Медленнее бинарных парсеров (декодирует изображение), но универсален.
 */
export class BrowserImageReader {
  /**
   * Читает размеры изображения через создание Image элемента.
   * Использует createObjectURL для эффективности.
   */
  async readDimensions(file: File): Promise<ImageDimensions | null> {
    return new Promise(resolve => {
      const url = URL.createObjectURL(file);
      const img = new Image();

      const cleanup = (): void => {
        URL.revokeObjectURL(url);
      };

      img.onload = (): void => {
        resolve({ width: img.naturalWidth, height: img.naturalHeight });
        cleanup();
      };

      img.onerror = (): void => {
        resolve(null);
        cleanup();
      };

      img.src = url;
    });
  }
}
